<template>
  <div>
    <!-- self-assessment start  -->
    <section class="self_assessment_sec d-flex justify-content-center align-items-center">
      <div class="container px-lg-0">
        <div class="row">
          <div class="col-md-12">
            <div class="give_para mt_80 mb_120 text-center" style="padding:20px; height:800px">
              
              <iframe :src="company_data.formlink_self_assessment+'?firstname='+this.user_data.first_name+'&lastname='+this.lastName+'&email='+this.user_data.email" frameborder="0" style="width: 100%;
              height: 649px;
              margin-top: 67px;"></iframe>
            </div>
          </div>

          <div class="col-md-12">
            <div class="self_assess_main_box">
              <h2></h2>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- self-assessment end  -->
    <section class="already_completed text-center my_54" v-if="company_data.schedule_request_status">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-8">
            <div>
              <h3 class="text_black">Already completed a self-assessment?</h3>
              <p class="text_balticsea">Already completed your self-assessment, but still need a bit more help? We’ve got you covered. Schedule a one-on-one ergo evaluation with one of our leading ergonomists.</p>
              <router-link :to="{ name:'schedule_eval' }" class="btn btn_primary">Schedule an Evaluation</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  // import carousel from "vue-owl-carousel"
  export default {
    name: 'self_assessment',
    data() {
         return {
            // company_data : null,
            company_data : this.$store.getters["auth/authUser"].client ?? null,
            user_data: {},
            lastName:"",
            iframeUrl: null,
         };
      },
    components: {
      // carousel
    },
    mounted(){
        // this.company_data = JSON.parse(localStorage.getItem("companyInformation"));  
        let data = this.$store.getters["auth/authUser"];
        this.company_data = data.client;
        this.user_data = data.user;
        this.lastName = this.user_data.last_name ? this.user_data.last_name : "";
        
      }
  }
</script>
